// @flow

// import {apiAxios} from "../../axiosConfig";

import type {AuthBloc} from "../../blocs/authBloc";
import type User from "../../models/User/User";
import {apiAxios} from '../../config/AxiosConfig'
import { AppToaster } from "../../components/Toaster/Toaster";
import { Intent } from "@blueprintjs/core";


class UserApi {

    authBloc : AuthBloc;

    constructor(authBloc: AuthBloc) {
        this.authBloc = authBloc;
    }

    async getUser(userId: string) : Promise<User> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.get(`/tenants/${tenantId}/user/${userId}`, this.buildHeaders());

        if (response.status !== 200) {
            throw new Error(response.status);
        }

        return response.data;
    }

    async getAllUsers() : Promise<Array<User>> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.get(`/tenants/${tenantId}/users`, this.buildHeaders());

        if (response.status !== 200) {
            return [];
        }

        return response.data || [];
    }

    async createUser(userInfo: Object) : Promise<User> {
        const tenantId = this.authBloc.getCurrentTenant();

        try {
            const response = await apiAxios.post(`/tenants/${tenantId}/users`, userInfo, this.buildHeaders());

            if (!response.data || response.data.errorMessage) {
                setTimeout(() => {
                    AppToaster.show({
                        message: "User Already Exists",
                        intent: Intent.DANGER,
                    });
                }, 300);
            } else {
                setTimeout(() => {
                    AppToaster.show({
                        message: "New User Added",
                        intent: Intent.SUCCESS,
                    });
                }, 300);
            }

            return response.data;
        } catch (error) {
            AppToaster.show({
                message: "Something went wrong while creating user!",
                intent: Intent.DANGER,
            });
            throw error;
        }
    }

    async updateUser(userId: string, userInfo: Object) : Promise<User> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.put(`/tenants/${tenantId}/users/${userId}`, userInfo, this.buildHeaders());

        if (response.data.errorMessage) {
            setTimeout(() => {
                AppToaster.show({
                    message: "User Email Already Exists",
                    intent: Intent.DANGER,
                });
            }, 300);
        } else {
            setTimeout(() => {
                AppToaster.show({
                    message: "User Updated",
                    intent: Intent.SUCCESS,
                });
            }, 300);
        }

        return response.data;
    }

    async deleteUser(userId: string) : Promise<void> {
        const tenantId = this.authBloc.getCurrentTenant();

        try {
            await apiAxios.delete(`/tenants/${tenantId}/users/${userId}`, this.buildHeaders());
            setTimeout(() => {
                AppToaster.show({
                    message: "User Deleted",
                    intent: Intent.SUCCESS,
                });
            }, 300);
        } catch (error) {
            AppToaster.show({
                message: "Something went wrong while deleting user!",
                intent: Intent.DANGER,
            });
            throw error;
        }
    }

    async getProjectMangers() : Promise<Array<User>> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.get(`/tenants/${tenantId}/groups/project_managers`, this.buildHeaders());

        if (response.status !== 200) {
            throw new Error(response.status);
        }

        return response.data;
    }
    async getProjectAdmins() : Promise<Array<User>> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.get(`/tenants/${tenantId}/groups/project_admins`, this.buildHeaders());

        if (response.status !== 200) {
            throw new Error(response.status);
        }

        return response.data;
    }

    async getTenantAdmins() : Promise<Array<User>> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.get(`/tenants/${tenantId}/groups/tenant_admins`, this.buildHeaders());

        if (response.status !== 200) {
            throw new Error(response.status);
        }

        return response.data;
    }

    buildHeaders = ()=> {
        const accessToken = this.authBloc.getCurrentToken();
        const auth = "Bearer " + accessToken;
        return {headers:{Authorization:auth}};
    }
}

export default UserApi;
